module.exports = __webpack_public_path__ + "img/fakefact_not.2edfc120.jpg";